// API utility functions
const API_BASE_URL = process.env.REACT_APP_API_URL;

const TOKEN_KEY = 'rodeoke_token';

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
export const setToken = (token: string): void => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = (): void => localStorage.removeItem(TOKEN_KEY);

export const apiUrl = (path: string): string => {
  // If running in Docker (REACT_APP_API_URL is set), use full URL
  if (API_BASE_URL) {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${API_BASE_URL}/${cleanPath}`;
  }

  // If running locally (no REACT_APP_API_URL), use relative paths for proxy
  return path;
};

// Helper function for API calls — auto-attaches auth token and handles 401
export const apiCall = async (path: string, options: RequestInit = {}): Promise<Response> => {
  const url = apiUrl(path);
  const token = getToken();

  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(url, { ...options, headers });

  // On 401, clear auth state and redirect to login
  if (response.status === 401) {
    clearToken();
    localStorage.removeItem('rodeoke_member');
    // Only redirect if not already on login page
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/gig/login';
    }
  }

  return response;
};
